import { ADICIONAR_FILTRO_FECHAMENTO_CAIXA } from '../types'

export default function adicionarFiltroFechamentoCaixa (filtro) {
  return {
    type: ADICIONAR_FILTRO_FECHAMENTO_CAIXA,
    payload: filtro
  }
}
